function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
jQuery(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty(jQuery('#product'))) {
    jQuery('#product .option-container').addClass('has-option');
  }
});
jQuery("#spicegems_cr_btn_no").click(function(){
    jQuery(this).parents(".spicegems_cr_modal").remove()
    jQuery(".modal-backdrop").remove();
    jQuery("body").removeClass(".modal-open");
});
function divWidthMenu() {
  var width_br = jQuery(".container-fix .block-right").outerWidth(true);
  var width_count = jQuery(".container-fix > .container").width();
  var width_bl = jQuery("#logo img").outerWidth(true);
  if (jQuery(".hd1").length || jQuery(".hd2").length) {
    jQuery('.home1 .container-fix .`main-menu').outerWidth(width_count - width_bl - width_br-30);
  }
}
function customResponsive(){
  var window_w = parseInt(jQuery(window).width());

  jQuery(".group1 #logo img").each(function() {
    if( this.complete ) {
      divWidthMenu.call( this );
    } else {
      jQuery(this).one('load', divWidthMenu);
    }
  });

  var offsetMargin = 0-jQuery('.wrapper').outerWidth(true)*2.6/100;
  if ( jQuery(".hd2").length ) {
    jQuery('.banner8').css('margin-left',offsetMargin);
    jQuery('.banner8').css('margin-right',offsetMargin);
  }
}
jQuery(window).resize(function() {
  customResponsive();
});
 //jQuery('#input-sort').click(function(e) {
  // var selectheight = jQuery(this).height();
   //var scrollPos = jQuery(this).offset().top;
   //var selectoptioncount = jQuery(this).find("option").length;
   //var totaloffset = jQuery(selectoptioncount*selectheight+scrollPos);
   //var selectsize = jQuery(selectoptioncount*selectheight);
   //e.preventDefault();
   // jQuery('html, body').animate({
   ////   scrollTop: jQuery(jQuery(e.target).attr("id","gf-products")).offset().top
   // }, 0);
   //console.log(totaloffset);
   //console.log(selectoptioncount*selectheight);
  //});
jQuery(document).ready(function() {
  //jQuery( ".main_menu li .sub_menu" ).wrapAll("<div class='subnavmain'></div>");
  jQuery( ".main_menu li .subnavmain" ).before("<span class='dropdown'></span>");
  jQuery('.dropdown').click(function() {
      jQuery(this).next().toggleClass("showdropdown");
  });
  
  jQuery( ".main_menu li .subnavmain").each(function(e){
    if (jQuery(this).find('.mega-menu-title').length) {
    } else {
      jQuery(this).find('.sub_menu').addClass('linewise');
    }
  });
  var className = jQuery('header').attr('class');
  if (jQuery(".header3").length) {
    jQuery('.contentforlayout').addClass('container1-page');
  }

  // vertical thumbs on product page
  

  // product video
  jQuery('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color / option swatch js snippet
  // jQuery('.swatch :radio').change(function(e) {
  //   if (jQuery(this).prop('disabled')) {
  //     e.stopPropagation();
  //   } else {
  //     var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
  //     var optionValue = jQuery(this).val();
  //     let variants = this.getAttribute('data-product');
  //     const parsedVariants = JSON.parse(variants);
  //    // Array to store matched variants
  //     const matchedVariants = [];

  //     // Loop through all parsedVariants
  //     parsedVariants.forEach(variant => {
  //         // Check if any option matches the selected size value
  //         if (variant.options.some(opt => opt === this.value)) {
  //             matchedVariants.push(variant);
  //         }
  //     });

  //     // Now loop through all matched variants
  //     matchedVariants.forEach(variant => {
  //         // Get the size selector container (DOM element)
  //         const sizeSelector = jQuery(this).closest('form').find('#sizelist')[0];

  //         if (!sizeSelector) {
  //             console.warn('Size selector not found');
  //             return;
  //         }
  //         // Get all .size-product inputs inside the container
  //         const sizeInputs = sizeSelector.querySelectorAll('.size-product');
  //         // Loop through each size input
  //         sizeInputs.forEach((input, index) => {
  //             console.log(`Size input ${index}:`, input.value);

  //             // Optional: Check if this input matches the current variant
  //             if (variant.options.includes(input.value)) {
  //               const parent = input.parentElement;       // Parent wrapper div
  //               const label = parent.querySelector('.size-lbl');  // Label inside parent
              
  //               if (variant && variant.available) {
  //                 input.disabled = false;
  //                 input.classList.remove('unavailable');
  //                 parent.classList.remove('soldout');    // soldout class on parent
  //                 if (label) {
  //                   const outSpan = label.querySelector('.out-size');
  //                   if (outSpan) outSpan.remove();       // remove "Out of Stock" span
  //                 }
  //               } else {
  //                 input.disabled = true;
  //                 input.classList.add('unavailable');
  //                 parent.classList.add('soldout');       // soldout class on parent
  //                 if (label) {
  //                   if (!label.querySelector('.out-size')) {
  //                     const outSizeSpan = document.createElement('span');
  //                     outSizeSpan.className = 'out-size';
  //                     outSizeSpan.textContent = ' Out of Stock ';
  //                     label.appendChild(outSizeSpan);    // add span inside label
  //                   }
  //                 }
  //               }
  //             }
              
              
  //         });
  //     });


  //     // Sync Shopify's option selectors so the correct variant ID is selected
  //     jQuery(this)
  //       .closest('form')
  //       .find('.single-option-selector')
  //       .eq(optionIndex)
  //       .val(optionValue)
  //       .trigger('change');

  //     // If there is no size selector on this product (color‑only product),
  //     // automatically enable the sticky "Add to cart" button once a color is chosen.
  //     if (jQuery('#form_buy input.size-product').length === 0) {
  //       jQuery('#button-cart-duplicate')
  //         .addClass('active')
  //         .html('Add to Cart');
  //     }
  //   }
  // });
// Function to update size options and Add to Cart button
let pageLoad = true; // global flag

function updateSizeOptions(selectedRadio) {
    if (jQuery(selectedRadio).prop('disabled')) return;

    const optionIndex = parseInt(jQuery(selectedRadio).closest('.swatch').attr('data-option-index'));
    const optionValue = jQuery(selectedRadio).val();

    const variants = JSON.parse(selectedRadio.getAttribute('data-product'));

    // Match variants by option index (correct way)
    const matchedVariants = variants?.filter(v => v.options[optionIndex] === optionValue);

    const formElement = jQuery(selectedRadio).closest('form');
    const sizeSelector = formElement.find('#sizelist')[0];

    if (sizeSelector) {
        const sizeInputs = sizeSelector.querySelectorAll('.size-product');

        sizeInputs.forEach(input => {
            const inputValue = input.value;

            const correspondingVariant = matchedVariants?.find(v => v.options.includes(inputValue));

            const parent = input.parentElement;
            const label = parent.querySelector('.size-lbl');

            if (correspondingVariant) {
                if (correspondingVariant.available) {
                    input.disabled = false;
                    input.classList.remove('unavailable');
                    parent.classList.remove('soldout');

                    const outSpan = label?.querySelector('.out-size');
                    if (outSpan) outSpan.remove();
                } else {
                    input.disabled = true;
                    input.classList.add('unavailable');
                    parent.classList.add('soldout');

                    if (label && !label.querySelector('.out-size')) {
                        const outSizeSpan = document.createElement('span');
                        outSizeSpan.className = 'out-size';
                        outSizeSpan.textContent = ' Out of Stock ';
                        label.appendChild(outSizeSpan);
                    }
                }
            }
        });
    }

    // Update Shopify hidden selectors
    const formSelector = formElement.find('.single-option-selector').eq(optionIndex);
    formSelector.val(optionValue);

    if (!pageLoad) formSelector.trigger('change');

    // Update Add to Cart button
    const sizeInputs = formElement.find('input.size-product');
    let anyAvailable = sizeInputs.length === 0;

    if (!anyAvailable) {
        sizeInputs.each(function() {
            if (!jQuery(this).prop('disabled')) anyAvailable = true;
        });
    }

    const addToCartBtn = jQuery('#button-cart-duplicate');
    if (anyAvailable) {
        addToCartBtn.addClass('active').text('Add to Cart');
    } else {
        addToCartBtn.removeClass('active').text('Sold Out');
    }
}

// iOS FIX — Safari requires input+click+change
jQuery('.swatch :radio').on('change input click', function() {
    if (!jQuery(this).prop('disabled')) {
        pageLoad = false;
        updateSizeOptions(this);
        pageLoad = true;
    }
});

// On page load
jQuery(document).ready(function() {
    jQuery('.swatch :radio:checked').each(function() {
        updateSizeOptions(this);
    });
});



  
  
  jQuery('.size-lbl').click(function(e) {
    if (jQuery(this).parent('.swatch-element').find('.size-product').prop('disabled')) {
      e.stopPropagation();
    } else {
      jQuery(this).parent('.swatch-element').find('.size-product').prop("checked", true).trigger("click");
      
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).parent('.swatch-element').find('.size-product').val();
      console.log(optionValue);
      jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    }
    
  });

//   jQuery(".accessories-modal-submit").unbind();
//   jQuery('.accessories-modal-submit').on('click', function(e) {
//   	e.preventDefault();
//     console.log('here');
//     return;
//   });
  // product page add to cart
  //jQuery('#button-cart').on('click', function(e) {
 
  
  jQuery('#button-cart').on('click', function(e) {
    e.preventDefault();
    	var product_id = jQuery('#form_buy #productSelect').val();
		var quantity = jQuery('#form_buy input.num-product').val();
        var productsize = jQuery('#form_buy input.size-product:checked').val();

//     datax={
//       "id"       : jQuery("#productSelect").children("option:selected").val(),
//       "quantity" : jQuery("#Quantity").val()
//     };
    if (jQuery('#form_buy input.size-product').length == 0) {
      productsize = 1;
    }
    if(typeof (productsize) !==  'undefined')
    {
      
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      //data: jQuery('#form_buy input[type=\'text\'], #form_buy select'),
//       data:datax,
      data: 'id=' + product_id + '&quantity=' + (typeof (quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        jQuery('#button-cart').button('loading');
      },
    
      complete: function() {
        jQuery('#button-cart').button('reset');
      },
      success: function(json) {
           
        console.log(json);
        jQuery('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
        jQuery('.cart-popup-wrapper').addClass('menu-open');
        addTocartPopup(json,quantity);
        jQuery('.alert, .text-danger').remove();
        jQuery('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = jQuery('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            jQuery('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          jQuery('.text-danger').parent().addClass('has-error');
        }

//         swal("Added to Cart confirmation !", "");
      
        $.getJSON('/cart.js', function(cart) {
//          console.log(cart);
          jQuery('.cart-total').html(cart.item_count);
          if(cart.item_count < 1) {
            jQuery('.cart-total').addClass("hide");
          } else {
             jQuery('.cart-total').removeClass("hide");
          }
          jQuery(".cart-total").attr("data-item", cart.item_count);
          Currency?.convertAll(shopCurrency, Currency?.cookie.read());
        });
		jQuery('.swal-button--confirm').on('click', function(e) {
//           location.reload();
        });
        jQuery('html, body').animate({ scrollTop: 0 }, 'slow');

        jQuery('#cart').load('/ #cart #subcart');
        jQuery('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
        //        jQuery('#cart > .top-cart-contain ul').load('/ #cart > .top-cart-contain ul li');
        //  jQuery('#cart > ul').load('/ #cart > ul li');
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
       
        


var data=xhr.responseText;
var jsonResponse = JSON.parse(data);
 var desc = jsonResponse["description"];
//        alert(desc);
        swal("Sorry!","You can't add more item in to the cart.", "error")
      }
    });
    
    }
    else
    {
       swal("Sorry!","Please Select the size.", "error")
        jQuery('#button-cart').button('reset');
    }
  });
  
  //add product details to cart 
  
  function addTocartPopup(item,qty) {
    var sizedImageUrl = getSizedImageUrl(item.featured_image.url, '200x');
    var image = document.createElement('img');
    image.src = sizedImageUrl;
    image.alt = item.featured_image.alt;
    image.classList.add("cart-popup-item__image");

    jQuery('.cart-popup-item__image-wrapper').html(image);
    jQuery('.cart-popup-item__image-wrapper').removeClass('hide');
    jQuery('.cart-popup-item__title').text(item.product_title);
    jQuery('.cart-popup-item__quantity span[data-cart-popup-quantity]').text(qty);

    //     if(!multiple_var){
    if(item.options_with_values[0].value != 'Default Title') {
      jQuery('.cart-popup-item__description .product-details')
      .html('<li class="product-details__item">'+ item.options_with_values[0].name +': '+ item.options_with_values[0].value +'</li>');
    }
    //     }

    $.getJSON('/cart.js').then(
      function (cart) {
        jQuery("#CartCount").removeClass("hide");
        jQuery('a.cart-popup__cta-link span[data-cart-popup-cart-quantity]').text(cart.item_count);
        jQuery("#CartCount").children("[data-cart-count]").text(cart.item_count);
      }
    );
  }

  function closePopupRemoveDetails() {
    jQuery('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
    jQuery('.cart-popup-wrapper').removeClass('menu-open');
    jQuery('.cart-popup-item__image').remove();
    jQuery('.cart-popup-item__title').text('');
    jQuery('.cart-popup-item__image-wrapper').addClass('hide');
    jQuery('.product-details__item').remove();
    jQuery('.cart-popup-item__quantity span[data-cart-popup-quantity]').text('');
   }

  jQuery('.cart-popup__close').click(function(){
    closePopupRemoveDetails();
  });
  
  jQuery('.cart-popup__dismiss-button').click(function(){
    closePopupRemoveDetails();
  });

  jQuery(window).click(function(event){
    if (!jQuery(event.target).closest(".cart-popup-wrapper").length) {
      if (jQuery('.cart-popup-wrapper').hasClass('menu-open')) {
        closePopupRemoveDetails();
      }
    } 
  });
  
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  // move breadcrumbs
  jQuery("header").after('<div class="breadcrumbs"><div class="container"></div></div>');
  var breadcrumb = jQuery('ul.breadcrumb');
  var breadcrumbs_container = jQuery('.breadcrumbs .container');
  breadcrumb.appendTo(breadcrumbs_container);
  jQuery('.breadcrumb').before(jQuery('.category-name'));
  jQuery('.breadcrumb').before(jQuery('.block-2 .heading-title'));

  var sticky_menu = jQuery('#sticky-menu').attr('data-sticky');
  if (sticky_menu==1){
    var headerSpaceH = jQuery('header').outerHeight(true);
    jQuery('header').after('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');
  }
  // Scroll
  var currentP = 0;
  var stickyOffset = 0;

  stickyOffset = jQuery('header').offset().top;
  stickyOffset += jQuery('header').outerHeight();
  stickyOffset += 30;
  jQuery(window).scroll(function(){
    var headerH = jQuery('header').height();
    var scrollP = jQuery(window).scrollTop();

    if(jQuery(window).width() > 1024){
      if(scrollP != currentP){
        //Sticky header
        if (sticky_menu==1){
          if(scrollP >= stickyOffset){
            jQuery('.group1 .container-fix').addClass('fix-header');
            jQuery('.group2 .main-menu').addClass('fix-header');
            jQuery('.headerSpace').removeClass('unvisible');
          } else {
            jQuery('.group1 .container-fix').removeClass('fix-header');
            jQuery('.group2 .main-menu').removeClass('fix-header');
            jQuery('.headerSpace').addClass('unvisible');
          }
        }
        currentP = jQuery(window).scrollTop();
      }
    }
  });

  jQuery('.container-fix').hover(function(){
    jQuery(this).addClass("fix-header-act");
  },function(){
    jQuery(this).removeClass("fix-header-act");
  });

  customResponsive();

  if (!isEmpty(jQuery('#product'))) {
    jQuery('#product .option-container').addClass('has-option');
  }
  if (!isEmpty(jQuery('#product2'))) {
    jQuery('#product2 .option-container').addClass('has-option');
  }

  // move toolbar category
  jQuery('.layer-category').prepend(jQuery('.custom-category .toolbar'));

  // Highlight any found errors
  jQuery('.text-danger').each(function() {
    var element = jQuery(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  jQuery('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';

    var value = jQuery('#search input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }

    location = url;
  });

  jQuery('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      jQuery('#search input[name=\'q\']').parent().find('button').trigger('click');
    }
  });

  // Menu
  jQuery('#menu .dropdown-menu').each(function() {
    var menu = jQuery('#menu').offset();
    var dropdown = jQuery(this).parent().offset();

    var i = (dropdown.left + jQuery(this).outerWidth()) - (menu.left + jQuery('#menu').outerWidth());

    if (i > 0) {
      jQuery(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  jQuery('#list-view').click(function() {
    jQuery('.custom-products').removeClass('custom-products-row');
    jQuery(this).addClass('selected');
    jQuery('#grid-view').removeClass('selected');
    jQuery('#content .product-grid > .clearfix').remove();

    //jQuery('#content .product-layout').attr('class', 'product-layout product-list col-xs-12');
    jQuery('#content .product-grid').attr('class', 'product-layout product-list col-xs-12');
    jQuery('#content .product-list .caption').addClass('col-xs-8');
    jQuery('#content .product-list .image').addClass('col-xs-4');


    localStorage.setItem('display', 'list');
  });

  // Product Grid
  jQuery('#grid-view').click(function() {
    jQuery('.custom-products').addClass('custom-products-row');
    jQuery(this).addClass('selected');
    jQuery('#list-view').removeClass('selected');
    // What a shame bootstrap does not take into account dynamically loaded columns
    cols = jQuery('#column-right, #column-left').length;

    if (cols == 2) {
      jQuery('#content .product-layout').attr('class', 'product-layout product-grid col-md-6 col-sm-6 col-xs-6 two-items');
    } else if (cols == 1) {
      jQuery('#content .product-layout').attr('class', 'product-layout product-grid col-md-4 col-sm-6 col-xs-6 three-items');
    } else {
      jQuery('#content .product-layout').attr('class', 'product-layout product-grid col-md-3 col-sm-6 col-xs-6 four-items');
    }
    jQuery('#content .product-grid .caption').removeClass('col-xs-8');
    jQuery('#content .product-grid .image').removeClass('col-xs-4');


    localStorage.setItem('display', 'grid');
  });

  if (localStorage.getItem('display') == 'list') {

    jQuery('#list-view').trigger('click');
  } else {
    jQuery('#grid-view').trigger('click');
  }

  // Checkout
  jQuery(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      jQuery('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  jQuery('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  jQuery(document).ajaxStop(function() {
    jQuery('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });
  
  
});

// Cart add remove functions
var cart = {
  'add': function(product_id, product_title, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = jQuery(this);
        jQuery('.btn-cart > .button').button('loading');
      },
      complete: function() {
        jQuery('.btn-cart > .button').button('reset');
      },
      success: function(json) {
        jQuery('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }
        swal(product_title, "is added to cart !", "success");
        // toastr.success('Congratulation! Your item has been added.')

        $.getJSON('/cart.js', function(cart) {
          setTimeout(function () {
            jQuery('.cart-total').html(cart.item_count);
            if(cart.item_count < 1) {
              jQuery('.cart-total').addClass("hide");
            } else {
              jQuery('.cart-total').removeClass("hide");
            }
            jQuery(".cart-total").attr("data-item", cart.item_count);
          }, 100);
          //Currency.convertAll(shopCurrency, Currency.cookie.read());
        });
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      beforeSend: function() {
        jQuery('#cart').removeClass('show-header-dropdown');
      },
      success: function(json) {
        jQuery('#cart > button').button('reset');
        setTimeout(function () {
          jQuery('.cart-total').html(json['item_count']);
          if(json['item_count'] < 1) {
            jQuery('.cart-total').addClass("hide");
          } else {
             jQuery('.cart-total').removeClass("hide");
          }
          jQuery(".cart-total").attr("data-item", json['item_count']);
        }, 100);
        // Currency.convertAll(shopCurrency, Currency.cookie.read());

        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
          //location = '/cart';
          location.reload();
        } else {
          jQuery('#cart').load('/ #cart #subcart');
          
          jQuery('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}
jQuery('#cart').load('/ #cart #subcart');

 jQuery('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
/* Agree to Terms */
jQuery(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();

  jQuery('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: jQuery(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + jQuery(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      jQuery('body').append(html);

      jQuery('#modal-agree').modal('show');
    }
  });
});
jQuery('.search-head').click(function() {
	jQuery(".search-drop").toggleClass("show-header-dropdown");
});

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      jQuery(this).attr('autocomplete', 'off');

      // Focus
      jQuery(this).on('focus', function() {
        this.request();
      });

      // Blur
      jQuery(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      jQuery(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

 


      
      // Click
      this.click = function(event) {
        event.preventDefault();

        value = jQuery(event.target).parent().attr('data-value');

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }

      // Show
      this.show = function() {
        var pos = jQuery(this).position();

        jQuery(this).siblings('ul.dropdown-menu').css({
          top: pos.top + jQuery(this).outerHeight(),
          left: pos.left
        });

        jQuery(this).siblings('ul.dropdown-menu').show();
      }

      // Hide
      this.hide = function() {
        jQuery(this).siblings('ul.dropdown-menu').hide();
      }

      // Request
      this.request = function() {
        clearTimeout(this.timer);

        this.timer = setTimeout(function(object) {
          object.source(jQuery(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }

      // Response
      this.response = function(json) {
        html = '';

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }

              category[json[i]['category']]['item'].push(json[i]);
            }
          }

          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        jQuery(this).siblings('ul.dropdown-menu').html(html);
      }

      jQuery(this).after('<ul class="dropdown-menu"></ul>');
      jQuery(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

    });
  }
})(window.jQuery);

      jQuery(document).ready(function() {
	      var display_time; //= jQuery("#newsletter-popup-conatiner").attr("data-display_time");
        
        display_time = 10;
        
        display_time = parseInt(display_time) * 1000 ;
         console.log(display_time);
    // Hide the div
    jQuery("#newsletter-popup-conatiner").hide();

    // Show the div in 5s
    jQuery("#newsletter-popup-conatiner").delay(display_time).fadeIn(500);
        
//         setTimeout(function() {
//             jQuery('#newsletter-popup-conatiner').fadeOut(500);
//         }, display_time); 

        
        jQuery("#msg-popup-conatiner").hide();
        jQuery('#msg-popup-trigger').click(function() {
        	jQuery("#msg-popup-conatiner").fadeIn(500);
        });
        
        jQuery("#msg-popup-conatiner .hide-popup").click(function() {
            jQuery("#msg-popup-conatiner").fadeOut(500);
        });
        
        jQuery(document).click(function(event) {
        if (jQuery(event.target).is("#msg-popup-conatiner")) {
          jQuery("#msg-popup-conatiner").fadeOut(500);
        }
      });
});


jQuery("#sizelist").on("click", "label", function(event){
  if( jQuery(this).parent("li").hasClass( "available" ))
  {
	 radio_value = jQuery(this).prev("input[type='radio']").val();

    jQuery("#size-btn").html(radio_value); 
    jQuery('#button-cart-duplicate').html('Add to cart');
    jQuery('#button-cart-duplicate').addClass('active');
}
})


var ua = navigator.userAgent.toLowerCase(); 
if (ua.indexOf('safari') != -1) { 
  if (ua.indexOf('chrome') > -1) {
   
  } else {
   
   jQuery("#sizelist li.swatch-element").click(function(){
     
     jQuery("#sizelist").removeClass("show");
     jQuery("#size-btn").text(jQuery(this).attr("data-value"));
    jQuery('#button-cart-duplicate').html('Add to cart');
     jQuery('#button-cart-duplicate').addClass('active');
  });
  }
}
jQuery("#button-cart-duplicate").click(function(){
  if (jQuery(this).hasClass('active')) {
    jQuery('#button-cart').trigger('click');
  } else {
    jQuery('html, body').animate({
        scrollTop: jQuery("#size-btn").offset().top - 300
    }, 100);
  }
});
// jQuery(".wrap-table-shopping-cart button.remove").on("click", function(){
//  jQuery(this).parents("tr").remove();
//   location.reload();
// })

jQuery( ".reload-remove-cart-page" ).click(function() {
  
  	setTimeout(
            function() {
                  location.reload();
            },
            500);
});

jQuery('.custom-dropdown').click(function() {
      console.log('test')
        jQuery('.dropdown-content').toggleClass('show');
    });

jQuery(document).click(function(event) {
  if (!jQuery(event.target).closest('.search-head').length) {
    if (jQuery(".header-dropdown").hasClass("show-header-dropdown")) {
      jQuery(".header-dropdown").removeClass("show-header-dropdown");
    }
  }
  
  if (!jQuery(event.target).closest('.custom-dropdown').length) {
    if (jQuery(".dropdown-content").hasClass("show")) {
      jQuery(".dropdown-content").removeClass("show");
    }
  }
});  

jQuery(document).ready(function() {
  var x1 = jQuery(".cart-total").attr("data-item");
  console.log(x1);
  if(x1 == 0) {
    jQuery(".cart-total").addClass("hide");
  } else {
  	jQuery(".cart-total").removeClass("hide");
  }
});

jQuery(document).ready(function() {
  var j = 0;
  jQuery('.blog-article .related-products .related-products-lists').each(function(){
    var productlength = jQuery('.blog-article .related-products .related-products-lists').length;
    j++; 
    if(j>4) {
     jQuery(this).remove();
    } 
    
    if(productlength < 4){
      jQuery(this).parent().addClass("centerProduct");
      jQuery(this).parent().parent().children(".title-related-products").addClass("text-center");
    }
  });
});
